import { createStackNavigator } from '@react-navigation/stack';
import React from 'react';
import { NAVIGATION_CONFIG } from '@v2/pages/common/constants/base.constants';
import { jobDetailsToolConfig } from './config';

const JobDetailsToolStack = createStackNavigator();

const JobDetailsToolNavigator = () => {
  return (
    <JobDetailsToolStack.Navigator screenOptions={NAVIGATION_CONFIG}>
      {jobDetailsToolConfig.map(({ Component, name }) => (
        <JobDetailsToolStack.Screen key={name} name={name} component={Component} />
      ))}
    </JobDetailsToolStack.Navigator>
  );
};

export { JobDetailsToolNavigator };
